import type { ApiClient } from 'clients/yogi-api'
import type {
  ChartRequest,
  ChartRunResponse,
  FieldCatalogResponse,
} from 'features/charts-v2/types/yogiql'
import { checkYogiQLVersion } from 'features/charts-v2/utils/yogiql-version'

const FIELD_CATALOG_URL = '/client/field-catalog'
const RUN_URL = '/client/run-chart'
// The hub travels in a header; the client already sends the raw Cognito id
// token as `Authorization` on every request, which is what these routes take.
const HUB_UUID_HEADER = 'X-Hub-UUID'

/** Typed client for the YogiQL chart routes behind `enhanced_dialect`. */
export class YogiQLChartsService {
  constructor(private client: ApiClient) {}

  async getFieldCatalog(hubUuid: string): Promise<FieldCatalogResponse> {
    const response = await this.client.get<FieldCatalogResponse>(
      FIELD_CATALOG_URL,
      { headers: { [HUB_UUID_HEADER]: hubUuid } },
    )
    return checkYogiQLVersion(response.data)
  }

  async run(hubUuid: string, request: ChartRequest): Promise<ChartRunResponse> {
    const response = await this.client.post<ChartRunResponse>(
      RUN_URL,
      request,
      { headers: { [HUB_UUID_HEADER]: hubUuid } },
    )
    return response.data
  }
}
